module.exports = __webpack_public_path__ + "img/mike.ae9ec4f6.png";